import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectAddress, selectBalance } from "../features/account";
import BigNumber from "bignumber.js";
import { selectPrice, setPrice } from "../features/trade";
import { useTokenSiteText } from "./language";
import { convertBitcoinNum } from "../utils/util";

const Price = () => {
  const [tokenVal, setTokenVal] = useState("0.00");

  const balance: string = useAppSelector(selectBalance);
  const address: string = useAppSelector(selectAddress);

  const dispatch = useAppDispatch();
  const startTimeStamp = 1739462400;
  const stableTimeStap = 2053743373;
  const startPrice = 0.001;
  const price: string = useAppSelector(selectPrice);
  const { text } = useTokenSiteText();
  const tokenSymbol = "FACE";

  const calPrice = () => {
    var t = new Date().getTime() / 1e3;
    if (t <= startTimeStamp) {
      dispatch(setPrice(startPrice.toString()));
    } else if (t >= stableTimeStap) {
      dispatch(setPrice("1.00"));
      // setPrice('1.00000005841');
      return;
    } else {
      const timePassed = t - startTimeStamp;
      dispatch(
        setPrice(
          (startPrice * Math.pow(2, timePassed / 31536e3)).toFixed(18)
        )
      );
    }
  };
  useEffect(() => {
    const val = BigNumber(balance).multipliedBy(price).toFixed(2);
    // console.log('token val is ', val);
    setTokenVal(val);
    // reFetchBalance();
  }, [price, balance]);
  useEffect(() => {
    calPrice();
    const I = setInterval(calPrice, 1000);
    return () => clearInterval(I);
  }, []);
  return (
    <div className=" select-none w-full flex flex-col items-center md:items-start  md:ml-3 gap-3">
      <p
        className="select-none font-Armstrong w-full text-center md:text-end text-xl font-bold md:text-3xl text-white pb-2 "
        style={{ letterSpacing: "2px" }}
      >
        {tokenSymbol}
      </p>
      <div className="w-full flex flex-col items-center md:items-start gap-1">
        <span className="font-ARM text-[10px] md:text-xs text-cyan-200/80">
          {text.pricePerToken} {tokenSymbol}
        </span>
        <p
          className="select-none font-Armstrong text-xl md:text-2xl text-gray-300"
          style={{ letterSpacing: "2px" }}
        >
          {price}
        </p>
      </div>
      <div
        className="select-none w-full flex flex-col justify-center items-end md:items-start gap-1"
        style={{ top: "58%" }}
      >
        <span className="font-ARM text-[10px] md:text-xs text-cyan-200/80">
          {text.myToken} {tokenSymbol}
        </span>
        <p className="select-none balance font-Armstrong text-gray-300">
          {balance}
        </p>
        <span className="font-ARM text-[10px] md:text-xs text-cyan-200/80">
          {text.estimatedValue}
        </span>
        <p className="select-none val font-Armstrong text-gray-300">
          Total: {tokenVal} SATs <span className="text-xs md:text-sm ">{"(≈ " + convertBitcoinNum(parseFloat(tokenVal)) + "₿)"}</span>
        </p>
      </div>
      <div className="w-full flex flex-col items-center md:items-start gap-1">
        <span className="font-ARM text-[10px] md:text-xs text-cyan-200/80">
          {text.wallet}
        </span>
        <p
          className="addr  font-Armstrong font-thin
                text-gray-300 overflow-hidden whitespace-nowrap text-center md:text-left w-full px-2 md:px-0"
          style={{ top: "80%" }}
        >
          {address}
        </p>
      </div>
    </div>
  );
};
export default Price;
